// src/main.jsx
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App.jsx"; // ✅ static import (avoids top-level await)
import ErrorBoundary from "./ErrorBoundary.jsx"; // ✅ Import Error Boundary

// Simple crash overlay
function showFatal(err) {
  console.error("[BOOT FATAL]", err);
  let box = document.getElementById("boot-error");
  if (!box) {
    box = document.createElement("div");
    box.id = "boot-error";
    box.style.cssText = `
      position:fixed;inset:0;display:flex;align-items:center;justify-content:center;
      padding:24px;background:rgba(0,0,0,.85);color:#fff;z-index:999999;
      font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
    `;
    document.body.appendChild(box);
  }
  box.innerHTML = `
    <div style="max-width:900px;width:100%">
      <h2 style="margin:0 0 12px 0;font-size:20px">App failed to start</h2>
      <pre style="white-space:pre-wrap;background:#111;padding:12px;border-radius:8px;max-height:50vh;overflow:auto">
${(err && (err.stack || err.message)) || String(err)}
      </pre>
      <p style="opacity:.8;margin-top:8px">
        Open your browser devtools → Console for full details.
      </p>
    </div>`;
}

function removePreInit() {
  const pre = document.getElementById("pre-init");
  if (pre) pre.remove();
}

// StrictMode only in production (no double effects in dev)
const RootWrapper = import.meta.env.PROD ? StrictMode : ({ children }) => <>{children}</>;

function boot() {
  const rootEl = document.getElementById("root");
  if (!rootEl) {
    showFatal(new Error("#root not found in index.html"));
    return;
  }

  const root = createRoot(rootEl);

  try {
    root.render(
      <RootWrapper>
        <BrowserRouter>
          <ErrorBoundary> {/* ✅ Wrap App with Error Boundary */}
            <App />
          </ErrorBoundary>
        </BrowserRouter>
      </RootWrapper>
    );
    removePreInit();
  } catch (err) {
    showFatal(err);
  }
}

boot();
